import { render, staticRenderFns } from "./notification-menu.vue?vue&type=template&id=68134559&"
import script from "./notification-menu.vue?vue&type=script&lang=js&"
export * from "./notification-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports